import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'
import { getChatBgId, setChatBgId } from '../api/chatBg.js'
import { getThemeAccent, setThemeAccent } from '../api/theme.js'

export default defineStore('configStore', {
	state: () => {
		return {
			electronMode: false, // 当前是否以客户端模式运行
			fullScreen: true, // 当前是否全屏
			chatBg: getChatBgId(), // 聊天背景预设 id
			themeAccent: getThemeAccent(), // 主色 #hex
			registration: {
				mode: []
			},
			webrtc: {},
			upload: {}
		}
	},
	actions: {
		setConfig(config) {
			this.webrtc = config.webrtc;
			this.registration = config.registration;
			this.upload = config.upload;
		},
		setElectronMode(mode) {
			this.electronMode = mode
		},
		setFullScreen(fullScreen) {
			this.fullScreen = fullScreen;
		},
		switchFullScreen() {
			this.fullScreen = !this.fullScreen;
		},
		setChatBg(id) {
			this.chatBg = setChatBgId(id);
		},
		setThemeAccent(color) {
			this.themeAccent = setThemeAccent(color);
			return this.themeAccent;
		},
		async loadConfig() {
			const config = await http({
				url: '/system/config',
				method: 'get'
			});
			// 正式环境建议屏蔽以下日志，避免泄露服务器信息
			console.log("系统配置", config)
			this.setConfig(config);
		}
	}
});
